module.exports = __webpack_public_path__ + "static/media/calendar_ics.59fb335c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/calendar_ics.png
// module id = 246
// module chunks = 0